import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import AdminNav from "./AdminNav";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import SimpleCard from "@gull/components/cards/SimpleCard";
import { RichTextEditor } from "@gull";
import { useNavigate } from "react-router-dom";
import { NotificationContainer, NotificationManager, } from "react-notifications";
import {
  scoreAcademicPerformance,
  describeAcademicRecord,
  latestAcademicRecord,
  scoreFinancialNeed,
  describeFinancialNeed,
} from "./components/config/scoring";

// The supporter dropdown saves enum values - show them as words
const PRIMARY_SUPPORTER_LABELS = {
    father: "Father",
    mother: "Mother",
    guardian_relative: "Guardian/Relative",
};

const scoreFamilyCircumstances = (application) => {
  const fatherAlive = application?.father_alive;
  const primarySupporter = application?.primary_supporter;

  if (fatherAlive === true || fatherAlive === "true") return 5;
  if (fatherAlive !== false && fatherAlive !== "false") return null;
  if (primarySupporter === "mother") return 9;
  if (primarySupporter === "guardian_relative") return 10;
  return null;
};

const ViewApplication = () => {
    const { id } = useParams();
    const [applicationid, setApplicationId] = useState([]);
    const navigate = useNavigate();
    const [financeamount, setFinanceAmount] = useState({
      finance_amount: 0, // Initial state for financial_need
      // Add other fields here if necessary
    });
    const [education, setEducation] = useState([]);
    // The academic records come from a separate request, so keep a ref to the
    // latest ones — the evaluation request below needs them but cannot see state.
    const educationRef = useRef([]);
    const [resume1, setResume1] = useState([]);
    const [resume2, setResume2] = useState([]);
    const [resume3, setResume3] = useState([]);
    const [resume4, setResume4] = useState([]);
    const [resume5, setResume5] = useState([]);
    const [resume6, setResume6] = useState([]);
    const [resume7, setResume7] = useState([]);
    const [acedemicuploads, setAcedemicUploads] = useState([]);
    const [financedetail, setFinanceDetail] = useState({});
    // Same reason as educationRef — the evaluation request needs the finance
    // details but cannot see the state it is about to be given.
    const financedetailRef = useRef({});
    const [personalstatement, setPersonalStatement] = useState({});
    const [applicationstatus, setApplicationStatus] = useState({});
    const [fundsrequested, setFundsRequested] = useState({});

    const [fields, setFields] = useState({});
    const [loading, setLoading] = useState(true);
    // Admin-composed email — the body is HTML and rendered by the mail client
    const [emailSubject, setEmailSubject] = useState("");
    const [emailBody, setEmailBody] = useState("");
    // Message editor shows either the visual (WYSIWYG) editor or the raw HTML source
    const [emailEditorMode, setEmailEditorMode] = useState("visual");
    const [emailPreview, setEmailPreview] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);
    // Emails recorded for this applicant, newest first
    const [emailLogs, setEmailLogs] = useState([]);
    const [expandedEmailLog, setExpandedEmailLog] = useState(null);
    const [evaluationId, setEvaluationId] = useState("");
    const [editingAcademicKey, setEditingAcademicKey] = useState(null);
    const [academicDraft, setAcademicDraft] = useState({ resultType: "percentage", value: "" });
    const [savingAcademicKey, setSavingAcademicKey] = useState(null);
    const fieldsRef = useRef({});

    
    const [data, setData] = useState({
      academic_performance: 0,
      financial_need: 0,
      personal_statement: 0,
        totalScore: 0,
        next_stage: false, // Store accept/reject as boolean

      });
    const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
    console.log("token",token)
    // const auth = JSON.parse(localStorage.getItem("auth_user_info"));

    // const applicantID = auth ? auth.id : null;

     // Handle input changes and update state


     const handleInputChangefinance = (event) => {
      console.log("event".event)
      const { name, value } = event.target; // Get name and value from the input field
      setFinanceAmount((prevState) => ({
        ...prevState,
        [name]: value, // Dynamically update the field in the state
      }));
    };

     useEffect(() => {
        const fetchData = async () => {
            fetch(`${process.env.REACT_APP_BASE_URL_strapi}/users/me?populate[evaluations][filters][application][documentId][$eq]=${id}`, { 
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}` // JWT token of the logged-in user
                }
              })
                .then(response => response.json())
                .then(evaluation => {
                  console.log('User with filtered evaluations:', evaluation);
              
                  const evaluations = evaluation.evaluations[0]; // Extract the filtered evaluations from the populated response
                  if (evaluations) {
                    // Fill the auto-scored fields from the applicant's data when
                    // nothing has been scored yet — a score the admin already set
                    // is kept.
                    const autoAcademic = scoreAcademicPerformance(educationRef.current) || 0;
                    evaluations.academic_performance = evaluations.academic_performance || autoAcademic;
                    const finance = financedetailRef.current;
                    const autoFinancial = scoreFinancialNeed(finance.income, finance.dependents) || 0;
                    evaluations.financial_need = evaluations.financial_need || autoFinancial;
                    const autoFamilyScore = scoreFamilyCircumstances(fieldsRef.current);
                    evaluations.personal_statement =
                      evaluations.personal_statement || autoFamilyScore || 0;
                    evaluations.totalScore =
                    evaluations.academic_performance +
                    evaluations.financial_need +
                    Number(evaluations.personal_statement || 0);
                    setData(evaluations)
                    setEvaluationId(evaluations.documentId); // Store the evaluation ID in the state for future updates

                    // Assuming evaluations are returned and are related to applications
                 
                  } else {
                    console.log('No evaluations related to the specified application found for the user');
                  }
                })
                .catch(error => {
                  console.error('Error fetching user and filtered evaluations:', error);
                });
              
        };
            // Fetch the latest campaign first
    
    
        fetchData();
      }, [id, token]);


  // The academic records arrive from a separate request, so fill Academic
  // Performance once they land. A score the admin has already set is kept.
  useEffect(() => {
    const autoAcademic = scoreAcademicPerformance(education);
    if (!autoAcademic) return;

    setData((prev) =>
      prev.academic_performance
        ? prev
        : {
            ...prev,
            academic_performance: autoAcademic,
            totalScore:
              autoAcademic +
              Number(prev.financial_need || 0) +
              Number(prev.personal_statement || 0),
          }
    );
  }, [education]);

  // Same for Financial Need, which comes from the finance details request.
  useEffect(() => {
    const autoFinancial = scoreFinancialNeed(financedetail?.income, financedetail?.dependents);
    if (!autoFinancial) return;

    setData((prev) =>
      prev.financial_need
        ? prev
        : {
            ...prev,
            financial_need: autoFinancial,
            totalScore:
              Number(prev.academic_performance || 0) +
              autoFinancial +
              Number(prev.personal_statement || 0),
          }
    );
  }, [financedetail]);

  // Family Circumstances is derived from the application's family details.
  // Existing non-zero evaluation scores remain editable and are not overwritten.
  useEffect(() => {
    const autoFamilyScore = scoreFamilyCircumstances(fields);
    if (autoFamilyScore === null) return;

    setData((prev) =>
      prev.personal_statement
        ? prev
        : {
            ...prev,
            personal_statement: autoFamilyScore,
            totalScore:
              Number(prev.academic_performance || 0) +
              Number(prev.financial_need || 0) +
              autoFamilyScore,
          }
    );
  }, [fields]);




  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    // If the input is a checkbox, store the checked state
    if (type === "checkbox") {
      setData((prevData) => ({
        ...prevData,
        [name]: checked, // Checkbox true or false
      }));
    } else {
      // Handle numeric input. Financial Need lands on half points, so this has
      // to accept decimals rather than truncating them to integers.
      const parsedValue = value === "" ? 0 : Math.round(parseFloat(value) * 10) / 10;

      if (parsedValue > 10) {
        alert("Score cannot be more than 10");
        return;
      }

      setData((prevData) => {
        const newData = {
          ...prevData,
          [name]: isNaN(parsedValue) ? 0 : parsedValue,
        };

        const totalScore = newData.academic_performance + newData.financial_need + newData.personal_statement;

        return {
          ...newData,
          totalScore, // Update the total score
        };
      });
    }
}
const handleButtonClick1 = async (event) => {
    if (!id || !token) {
      alert("Application ID or Token missing!");
      return;
    }
  
    try {
      // Check if an evaluation ID exists (from the useEffect)
      if (evaluationId) {
        // If evaluation ID exists, update the existing evaluation
        const updateResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations/${evaluationId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Pass the token for authentication
          },
          body: JSON.stringify({
            data: {
              academic_performance: data.academic_performance,
              financial_need: data.financial_need,
              personal_statement: data.personal_statement,
              next_stage: data.next_stage,
              application: id, // Send the application ID
            },
          }),
        });
  
        if (updateResponse.ok) {
            const responseData = await updateResponse.json();
            console.log("Evaluation created successfully:", responseData);
      
            // After creating the evaluation, fetch all evaluations related to the application
            const fetchEvaluationsResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations?filters[application][documentId][$eq]=${id}&populate=*`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`, // Pass the token for authentication
              },
            });
      
            if (fetchEvaluationsResponse.ok) {
              const evaluationsData = await fetchEvaluationsResponse.json();
              console.log("All evaluations fetched successfully:", evaluationsData);
             
              // Map through the evaluations and count the number of next_stage true/false
                const result = evaluationsData.data.reduce(
                    (acc, val) => {
                    if (val.next_stage === true) {
                        acc.trueCount++;
                    } else if(val.next_stage === false) {
                        acc.falseCount++;
                    }else{

                    }
                    return acc;
                    },
                    { trueCount: 0, falseCount: 0 }
                );

                // Check the conditions and return the appropriate value
                let finalDecision = "none"; // Default value
                if (result.trueCount >= 2) {
                    let  outgoingData = {
                      application_status:'approved'
                      }
                     try {
                      console.log(" did it come here ")
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                          method: 'PUT', 
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });
                    
                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }
                        navigate('/applications/new-applications');

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }



                    finalDecision = "yes";
                } else if (result.falseCount >= 2) {
                  let  outgoingData = {
                    application_status:'rejected'
                  }
                    try {
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                          method: 'PUT', 
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });
                    
                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }
                        navigate('/applications/new-applications');

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }

                    finalDecision = "no";
                }
                navigate('/applications/new-applications');

                console.log("Final decision:", finalDecision);
              // Handle the evaluations data (for example, update the state or display the data)
              // You can set the data in a state or manipulate it as needed
      
            } else {
              console.error("Failed to fetch evaluations:", fetchEvaluationsResponse);
              alert("Failed to fetch evaluations. Please try again.");
            }
          } else {
            console.error("Failed to create evaluation:", updateResponse);
            alert("Failed to create evaluation. Please try again.");
          }
      } else {
        // If no evaluation ID, create a new evaluation
        const createResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Pass the token for authentication
          },
          body: JSON.stringify({
            data: {
              academic_performance: data.academic_performance,
              financial_need: data.financial_need,
              personal_statement: data.personal_statement,
              next_stage: data.next_stage,
              application: id, // Send the application ID
            },
          }),
        });
  
        if (createResponse.ok) {
            const responseData = await createResponse.json();
            console.log("Evaluation created successfully:", responseData);
          
      
            // After creating the evaluation, fetch all evaluations related to the application
            const fetchEvaluationsResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations?filters[application][documentId][$eq]=${id}&populate=*`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`, // Pass the token for authentication
              },
            });
      
            if (fetchEvaluationsResponse.ok) {
              const evaluationsData = await fetchEvaluationsResponse.json();
              console.log("All evaluations fetched successfully:", evaluationsData);
      
              // Handle the evaluations data (for example, update the state or display the data)
              // You can set the data in a state or manipulate it as needed
                  
              // Map through the evaluations and count the number of next_stage true/false
              const result = evaluationsData.data.reduce(
                (acc, val) => {
                if (val.next_stage === true) {
                    acc.trueCount++;
                } else if(val.next_stage === false) {
                    acc.falseCount++;
                }else{

                }
                return acc;
                },
                { trueCount: 0, falseCount: 0 }
            );
            
            // Check the conditions and return the appropriate value
            let finalDecision = "none"; // Default value
            if (result.trueCount >= 2) {
                let  outgoingData = {
                  application_status:'approved'
                  }           
                 try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                      method: 'PUT', 
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json', // Ensure content-type is set to JSON
                      },
                      body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                    });
                
                    if (!response.ok) {
                      throw new Error('Failed to submit form');
                    }
                    navigate('/applications/new-applications');

                    const data = await response.json();
                    console.log(data);
                  } catch (error) {
                    console.error('Error:', error);
                  }



                finalDecision = "yes";
            } else if (result.falseCount >= 2) {
              let  outgoingData = {
                application_status:'rejected'
              }
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                      method: 'PUT', 
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json', // Ensure content-type is set to JSON
                      },
                      body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                    });
                
                    if (!response.ok) {
                      throw new Error('Failed to submit form');
                    }
                    navigate('/applications/new-applications');

                    const data = await response.json();
                    console.log(data);
                  } catch (error) {
                    console.error('Error:', error);
                  }

                finalDecision = "no";
            }
            navigate('/applications/new-applications');

            console.log("Final decision:", finalDecision);
          // Handle the evaluations data (for example, update the state or display the data)
          // You can set the data in a state or manipulate it as needed

      
            } else {
              console.error("Failed to fetch evaluations:", fetchEvaluationsResponse);
              alert("Failed to fetch evaluations. Please try again.");
            }
          } else {
            console.error("Failed to create evaluation:", createResponse);
            alert("Failed to create evaluation. Please try again.");
          }
      }
    } catch (error) {
      console.error("Error saving evaluation:", error);
      alert("An error occurred while saving the evaluation.");
    }
  };
  
const saveFinance = async () => {
  try {
    console.log("finance amount ", financeamount.finance_amount);

    const createResponse = await fetch(
      `${process.env.REACT_APP_BASE_URL_strapi}/finance-amounts`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Pass the token for authentication
        },
        body: JSON.stringify({
          data: {
            amount: financeamount.finance_amount,
            application: id, // Send the application ID
          },
        }),
      }
    );

    if (createResponse.ok) {
      const responseData = await createResponse.json();
      console.log("finance added successfully:", responseData);

      // Show success notification
      NotificationManager.success("Funds added sucessfully");


    } else {
      const errorData = await createResponse.json();
      console.error("Failed to save finance amount:", errorData);

      // Show error notification
      NotificationManager.error(
        "Failed to save finance amount. Please try again.",
        "Error"
      );
    }
  } catch (error) {
    console.error("Error occurred while saving finance amount:", error);

    // Show error notification for unexpected issues
    NotificationManager.error(
      "An unexpected error occurred. Please try again later.",
      "Error"
    );
  }
};

  
    const updateChalan = async () => {
    if (!financedetail?.documentId) {
      alert("Finance detail record not found!");
      return;
    }
    try {
      const updateResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL_strapi}/finance-details/${financedetail.documentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            data: {
              chalan: financedetail.chalan,
            },
          }),
        }
      );

      if (updateResponse.ok) {
        NotificationManager.success("Challan amount updated successfully");
      } else {
        const errorData = await updateResponse.json();
        console.error("Failed to update chalan:", errorData);
        NotificationManager.error("Failed to update challan amount. Please try again.", "Error");
      }
    } catch (error) {
      console.error("Error updating chalan:", error);
      NotificationManager.error("An unexpected error occurred. Please try again later.", "Error");
    }
  };

  const fetchData = useCallback(async () => {
        try {


            const response1 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/academic-details?filters[application][documentId][$eq]=${id}&populate[application][populate]=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const response2 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/academic-uploads?filters[application][documentId][$eq]=${id}&populate=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const response3 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/documents-uploads?filters[application][documentId][$eq]=${id}&populate=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const response4 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/finance-details?filters[application][documentId][$eq]=${id}&populate=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const response5 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/personal-statements?filters[application][documentId][$eq]=${id}&populate=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const response6 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/finance-amounts?filters[application][documentId][$eq]=${id}&populate=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            
            const data1 = await response1.json();
            const data2 = await response2.json();
            const data3 = await response3.json();
            const data4 = await response4.json();
            const data5 = await response5.json();
            const data6 = await response6.json();
            const applicationResponse = await fetch(
              `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[documentId][$eq]=${encodeURIComponent(id)}&fields[0]=father_alive`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
            );
            const applicationData = applicationResponse.ok
              ? await applicationResponse.json()
              : null;
            if (!applicationResponse.ok) {
              console.error(
                'Failed to fetch application father_alive:',
                applicationResponse.status,
                await applicationResponse.text()
              );
            }

            // One application can end up with several academic_uploads rows — each
            // submit used to create a new one. Show the marksheet from the most
            // recently updated row that actually holds a file.
            const marksheetRows = data2?.data || [];
            const currentMarksheet =
              [...marksheetRows]
                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                .find((m) => m.marksheet) || marksheetRows[0];

            setApplicationStatus(data1?.data[0]?.application?.application_status)
            console.log("hope5",data1);
            console.log("hope6",data1?.data[0]?.application?.id);

            setFinanceAmount((prevState) => ({
              ...prevState, // Keep other fields intact
              finance_amount: data6?.data[0]?.amount, // Set or update the 'amount' field
            }));
            setFundsRequested(data4?.data[0]?.funds_request)
            const relatedApplication = data1?.data[0]?.application;
            const directApplication = applicationData?.data?.[0];
            const applicationFields = {
              ...relatedApplication,
              father_alive: directApplication?.father_alive ?? relatedApplication?.father_alive ?? null,
            };
            fieldsRef.current = applicationFields;
            setFields(applicationFields);
            setApplicationId(data1?.data[0]?.application?.id)
              setEducation(data1.data);
              educationRef.current = data1.data;
              setResume1({url:data3?.data[0]?.attested_applicant_cnic_front?.url})
              setResume2({url:data3?.data[0]?.attested_applicant_cnic_back?.url})
              setResume3({url:data3?.data[0]?.student_id_card?.url})
              setResume4({url:data3?.data[0]?.attested_father_guardian_cnic_front?.url})
              setResume5({url:data3?.data[0]?.attested_father_guardian_cnic_back?.url})
              setResume6({url:data3?.data[0]?.paid_fee_challan?.url})
              setResume7({url:data3?.data[0]?.electricity_bill?.url})
              setAcedemicUploads({url:currentMarksheet?.marksheet?.url})
              setFinanceDetail(data4?.data[0])
              financedetailRef.current = data4?.data[0] || {};
              setPersonalStatement(data5?.data[0])
              console.log("data4?.data[0]",data4?.data[0])
        setTimeout(() => {
          setLoading(false);
            console.log("fields",fields);
            console.log("education",education);
            console.log("resume1",resume1);
            console.log("resume2",resume2);
            console.log("resume3",resume3);
            console.log("resume4",resume4);
            console.log("resume5",resume5);
            console.log("resume6",resume6);
            console.log("financedetail",financedetail);


            
        }, 1000);
        } catch (error) {
            console.error('Error fetching personal information data:', error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const startAcademicEdit = (edu, key) => {
      setEditingAcademicKey(key);
      setAcademicDraft({
        resultType: edu?.total_marks != null ? "percentage" : "cgpa",
        value: edu?.total_marks != null ? String(edu.total_marks) : String(edu?.cgpa ?? ""),
      });
    };

    const saveAcademicResult = async (edu, key) => {
      if (!edu?.documentId) {
        NotificationManager.error("Academic record ID is missing. The result was not updated.", "Error");
        return;
      }

      const value = academicDraft.value.trim();
      if (!value) {
        NotificationManager.error("Please enter a percentage or CGPA.", "Error");
        return;
      }

      let resultData;
      if (academicDraft.resultType === "percentage") {
        const percentage = Number(value);
        if (!Number.isFinite(percentage) || percentage < 0 || percentage > 100) {
          NotificationManager.error("Percentage must be between 0 and 100.", "Error");
          return;
        }
        resultData = { total_marks: Math.round(percentage), cgpa: null };
      } else {
        resultData = { total_marks: null, cgpa: value };
      }

      setSavingAcademicKey(key);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL_strapi}/academic-details/${edu.documentId}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: resultData }),
          }
        );
        if (!response.ok) {
          throw new Error(`Failed to update academic result (${response.status}).`);
        }

        const updatedEducation = education.map((record) =>
          record.documentId === edu.documentId ? { ...record, ...resultData } : record
        );
        setEducation(updatedEducation);
        educationRef.current = updatedEducation;
        setEditingAcademicKey(null);
        NotificationManager.success("Academic result updated successfully.");
      } catch (error) {
        console.error("Error updating academic result:", error);
        NotificationManager.error(error.message || "Failed to update academic result. Please try again.", "Error");
      } finally {
        setSavingAcademicKey(null);
      }
    };




    // Mark application as Verified
    const markAsVerified = async () => {
        if (!applicationid) {
            alert("Application ID missing!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: { application_status: 'verified' } })
            });

            if (!response.ok) {
                throw new Error('Failed to change status');
            }

            NotificationManager.success("Application marked as Verified");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error('Error changing status:', error);
            NotificationManager.error("Failed to change status. Please try again.");
        }
    };

    // Mark application as Draft (incomplete)
    const makeDraft = async () => {
        if (!applicationid) {
            alert("Application ID missing!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${applicationid}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: { application_status: 'incomplete' } })
            });

            if (!response.ok) {
                throw new Error('Failed to change status');
            }

            NotificationManager.success("Application marked as Draft");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error('Error changing status:', error);
            NotificationManager.error("Failed to change status. Please try again.");
        }
    };

    // Recorded emails for this applicant, newest first
    const fetchEmailLogs = useCallback(async () => {
        if (!id) return;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL_strapi}/application/email-logs?applicationId=${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (!response.ok) return;
            const logs = await response.json();
            setEmailLogs(logs);
        } catch (error) {
            console.error("Error fetching email logs:", error);
        }
    }, [id, token]);

    useEffect(() => {
        fetchEmailLogs();
    }, [fetchEmailLogs]);

    // Sends the admin-written HTML email to this applicant
    const sendEmailToApplicant = async () => {
        const applicantEmail = fields?.email;
        const auth = JSON.parse(localStorage.getItem("auth_user_info") || "{}");

        if (!applicantEmail) {
            NotificationManager.error("This applicant has no email address on file.");
            return;
        }

        setSendingEmail(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL_strapi}/otp/sendCustomEmail`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email: applicantEmail,
                        subject: emailSubject,
                        body: emailBody,
                        sent_by: auth?.name || auth?.username || "Admin",
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to send email");
            }

            NotificationManager.success("Email sent to the applicant");
            setEmailSubject("");
            setEmailBody("");
            setEmailPreview(false);
            fetchEmailLogs();
        } catch (error) {
            console.error("Error sending email:", error);
            NotificationManager.error("Failed to send email. Please try again.");
        } finally {
            setSendingEmail(false);
        }
    };

    // Email and contact
    let contacts = fields && fields.contact ? fields.contact.split(', ') : ['N/A', 'N/A', 'N/A'];

    // Remove 'L:' from the landline number
    if (contacts[2]) {
        contacts[2] = contacts[2].replace('L:', '');
    }
    // let fundingText = fields && fields.fundingRequest ? fields.fundingRequest : 'N/A';
    // let fundingTextFormatted = formatText(fundingText);

    // The applicant picks either "Percentage" or "CGPA" per academic entry, and
    // they land in different Strapi fields (total_marks vs cgpa). Label the
    // column after what was actually entered instead of always saying "Total Marks".
    const marksLabel =
      education?.length && !education.some((e) => e.total_marks != null)
        ? "CGPA"
        : "Percentage";

    // Say where the auto-filled Academic Performance score came from, so the
    // admin can see it is derived from the result and not typed in.
    const academicHint = useMemo(() => {
      const score = scoreAcademicPerformance(education);
      if (!score) return "";
      return `Auto-scored ${score} from ${describeAcademicRecord(latestAcademicRecord(education))}`;
    }, [education]);

    // Same for Financial Need, which is derived from the household income and
    // the number of dependents.
    const financialHint = useMemo(() => {
      const score = scoreFinancialNeed(financedetail?.income, financedetail?.dependents);
      if (!score) return "";
      return describeFinancialNeed(financedetail?.income, financedetail?.dependents);
    }, [financedetail]);

    return (
        <>
        <div className="app-admin-wrap layout-sidebar-large">
            <AdminNav />
            <div className="main-content-wrap d-flex flex-column sidenav-open">
                {
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-bubble spinner-bubble-primary m-5"></div>
                        </div>

                    ) : (
                        <div className="mb-4">
                          {applicationstatus !== 'final_stage' ? (

                            <SimpleCard title={`EVALUATION`} className="mb-4">
                            <Row className="justify-content-center">
                                <Col lg={8} md={10} sm={12} xs={12}>

                                    <div className="eval-score-card mb-3">
                                        <div className="eval-score-card__header">
                                            <span className="eval-score-card__label">Academic Performance</span>
                                            <span className="eval-score-card__value">{data.academic_performance || 0}/10</span>
                                        </div>
                                        <input
                                            type="range"
                                            name="academic_performance"
                                            value={data.academic_performance || 0}
                                            onChange={handleInputChange}
                                            className="eval-range"
                                            min="0"
                                            max="10"
                                            step="1"
                                        />
                                        {academicHint && (
                                            <p className="eval-score-card__hint">{academicHint}</p>
                                        )}
                                    </div>

                                    <div className="eval-score-card mb-3">
                                        <div className="eval-score-card__header">
                                            <span className="eval-score-card__label">Financial Need</span>
                                            <span className="eval-score-card__value">{data.financial_need || 0}/10</span>
                                        </div>
                                        <input
                                            type="range"
                                            name="financial_need"
                                            value={data.financial_need || 0}
                                            onChange={handleInputChange}
                                            className="eval-range"
                                            min="0"
                                            max="10"
                                            step="0.5"
                                        />
                                        {financialHint && (
                                            <p className="eval-score-card__hint">{financialHint}</p>
                                        )}
                                    </div>

                                    <div className="eval-score-card mb-3">
                                        <div className="eval-score-card__header">
                                            <span className="eval-score-card__label">Family Circumstances</span>
                                            <span className="eval-score-card__value">{data.personal_statement || 0}/10</span>
                                        </div>
                                        <input
                                            type="range"
                                            name="personal_statement"
                                            value={data.personal_statement || 0}
                                            onChange={handleInputChange}
                                            className="eval-range"
                                            min="0"
                                            max="10"
                                            step="1"
                                        />
                                    </div>

                                    <div className="eval-total-score mb-3">
                                        <span className="eval-total-score__label">Total Score</span>
                                        <span className="eval-total-score__badge">{data.totalScore}/30</span>
                                    </div>

                                    <div className="eval-decision mb-3">
                                        <label className="eval-decision__label">Decision</label>
                                        <div className="eval-decision__buttons">
                                            <button
                                                type="button"
                                                className="btn"
                                                style={{
                                                    backgroundColor: data.next_stage ? '#198754' : 'transparent',
                                                    borderColor: '#198754',
                                                    color: data.next_stage ? '#fff' : '#198754',
                                                    fontWeight: 600,
                                                    borderWidth: '2px',
                                                }}
                                                onClick={() => handleInputChange({ target: { type: 'checkbox', name: 'next_stage', checked: true } })}
                                            >
                                                ✓ Accept
                                            </button>
                                            <button
                                                type="button"
                                                className="btn"
                                                style={{
                                                    backgroundColor: !data.next_stage ? '#dc3545' : 'transparent',
                                                    borderColor: '#dc3545',
                                                    color: !data.next_stage ? '#fff' : '#dc3545',
                                                    fontWeight: 600,
                                                    borderWidth: '2px',
                                                }}
                                                onClick={() => handleInputChange({ target: { type: 'checkbox', name: 'next_stage', checked: false } })}
                                            >
                                                ✗ Reject
                                            </button>
                                        </div>
                                    </div>

                                    <div className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-primary px-4"
                                            style={{ color: '#fff', fontWeight: 600 }}
                                            onClick={handleButtonClick1}
                                        >
                                            Save Evaluation
                                        </button>
                                    </div>

                                </Col>
                            </Row>
                            </SimpleCard>
                            ) : (
                              <SimpleCard title={`FINANCIAL`} className="mb-4">
                                  <Row className="justify-content-center">
                                    <Col lg={8} md={10} sm={12} xs={12}>

                                      <div className="eval-score-card mb-3">
                                        <div className="eval-score-card__header">
                                            <span className="eval-score-card__label">Requested Funds</span>
                                            <span className="eval-score-card__value">PKR {fundsrequested || 0}</span>
                                        </div>
                                        <input
                                          type="text"
                                          value={fundsrequested || 0}
                                          disabled
                                          className="form-control"
                                        />
                                      </div>

                                      <div className="eval-score-card mb-3">
                                        <div className="eval-score-card__header">
                                            <span className="eval-score-card__label">Allocated Funds</span>
                                            <span className="eval-score-card__value">PKR {financeamount.finance_amount || 0}</span>
                                        </div>
                                        <input
                                          type="number"
                                          name="finance_amount"
                                          value={financeamount.finance_amount || 0}
                                          onChange={handleInputChangefinance}
                                          className="form-control"
                                          min="0"
                                        />
                                      </div>

                                      <div className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-primary px-4"
                                          style={{ color: '#fff', fontWeight: 600 }}
                                          onClick={saveFinance}
                                        >
                                          Save Financial
                                        </button>
                                      </div>

                                    </Col>
                                  </Row>
                                </SimpleCard>
                              )}

                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                    <SimpleCard title={`${fields && fields.name ? fields.name : 'N/A'}`}>

                                        <div className="d-flex justify-content-end mb-3">
                                            <button
                                                type="button"
                                                className="btn btn-outline-success"
                                                onClick={markAsVerified}
                                                disabled={applicationstatus === 'verified'}
                                            >
                                                <i className="i-Checked"></i> Mark as Verified
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary ms-2"
                                                onClick={makeDraft}
                                                disabled={applicationstatus === 'incomplete'}
                                            >
                                                <i className="i-Pen-2"></i> Make Draft
                                            </button>
                                        </div>

                                        <Tabs defaultActiveKey="home" id="home" className="view-application-tabs">
                                            <Tab eventKey="home" title="BASIC INFORMATION">
                                                {fields?.profile_picture?.url && (
                                                    <div className="mb-3">
                                                        <strong>Profile Picture:</strong>
                                                        <div className="d-inline-block ms-2">
                                                            <img
                                                                src={fields.profile_picture.url.startsWith('http') ? fields.profile_picture.url : `${process.env.REACT_APP_BASE_URL_strapi}${fields.profile_picture.url}`}
                                                                alt="Profile"
                                                                style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #e0e0e0' }}
                                                            />
                                                            <button type="button" className="btn btn-sm btn-outline-primary ms-2" onClick={() => window.open(fields.profile_picture.url.startsWith('http') ? fields.profile_picture.url : `${process.env.REACT_APP_BASE_URL_strapi}${fields.profile_picture.url}`, '_blank')}>View Full</button>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="row">
                                                    <p className='col-6'><strong>Name:</strong> {fields && fields.name ? fields?.name : 'N/A'}</p>
                                                    {/* <div className='col-6 row'> */}
                                                    <p className='col-6'><strong>Email:</strong> {fields && fields.email ? fields?.email : 'N/A'}</p>
                                                    {/* </div> */}
                                                    {/* <div className='col-6 row'> */}

                                                    <p className='col-6'><strong>Contact:</strong>  {fields && fields.phone_number ? fields.phone_number : 'N/A'}</p>
                                                    {/* </div> */}
                                                    <p className='col-6'><strong>Gender:</strong> {fields && fields.gender ? fields.gender : 'N/A'}</p>
                                                   
                                                    <p className='col-6'><strong>Date of Birth:</strong> {fields && fields.date_of_birth ? fields.date_of_birth : 'N/A'}</p>
                                                    <p className='col-6'><strong> Permenent Address:</strong> {fields && fields.permenent_address ? fields.permenent_address : 'N/A'}</p>
                                                    <p className='col-6'><strong>Temporary Address:</strong> {fields && fields.temporary_address ? fields.temporary_address : 'N/A'}</p>
                                                    <p className='col-6'><strong>Father Name:</strong> {fields && fields.father_name ? fields.father_name : 'N/A'}</p>
                                                    <p className='col-6'><strong>Father Alive:</strong> {fields?.father_alive === true || fields?.father_alive === 'true' ? 'Alive' : fields?.father_alive === false || fields?.father_alive === 'false' ? 'Deceased' : 'N/A'}</p>
                                                    <p className='col-6'><strong>Applicant CNIC:</strong> {fields && fields.applicant_cnic ? fields.applicant_cnic : 'N/A'}</p>
                                                    <p className='col-6'><strong>Parent CNIC:</strong> {fields && fields.parent_cnic ? fields.parent_cnic : 'N/A'}</p>
                                                    <p className='col-6'><strong>city:</strong> {fields && fields.city ? fields.city : 'N/A'}</p>

                                                    <p className='col-12'><strong>How did you hear about this scholarship?</strong> {personalstatement && personalstatement.detail ? personalstatement.detail : 'N/A'}</p>

                                                </div>
                                            </Tab>
                                            <Tab eventKey="academic" title="ACADEMIC">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Institute</th>
                                                            <th scope="col">Degree</th>
                                                            <th scope="col">Start Year </th>
                                                            <th scope="col">End Year </th>
                                                            <th scope="col">Filed OF Study </th>                     
                                                            <th scope="col">{marksLabel}  </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {education && education?.map((edu, index) => (
                                                            <tr key={edu?.documentId || edu?.id || index}>
                                                                <th scope="row">{edu?.institute || 'N/A'}</th>
                                                                <td>{edu?.degree || 'N/A'}</td>
                                                                <td>{edu?.start_year || 'N/A'}</td>
                                                                <td>{edu?.end_year || 'N/A'}</td>
                                                                <td>{edu?.field_of_study || 'N/A'}</td>
                                                                <td>
                                                                    {editingAcademicKey === (edu?.documentId || edu?.id || index) ? (
                                                                        <div className="d-flex flex-column gap-2">
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                aria-label="Academic result type"
                                                                                value={academicDraft.resultType}
                                                                                onChange={(event) =>
                                                                                    setAcademicDraft((draft) => ({
                                                                                        ...draft,
                                                                                        resultType: event.target.value,
                                                                                    }))
                                                                                }
                                                                            >
                                                                                <option value="percentage">Percentage</option>
                                                                                <option value="cgpa">CGPA</option>
                                                                            </select>
                                                                            <input
                                                                                className="form-control form-control-sm"
                                                                                type={academicDraft.resultType === "percentage" ? "number" : "text"}
                                                                                inputMode="decimal"
                                                                                min="0"
                                                                                max={academicDraft.resultType === "percentage" ? "100" : undefined}
                                                                                step={academicDraft.resultType === "percentage" ? "any" : "0.01"}
                                                                                aria-label={academicDraft.resultType === "percentage" ? "Percentage" : "CGPA"}
                                                                                value={academicDraft.value}
                                                                                onChange={(event) =>
                                                                                    setAcademicDraft((draft) => ({
                                                                                        ...draft,
                                                                                        value: event.target.value,
                                                                                    }))
                                                                                }
                                                                            />
                                                                            <div className="d-flex gap-2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-success"
                                                                                    onClick={() => saveAcademicResult(edu, edu?.documentId || edu?.id || index)}
                                                                                    disabled={savingAcademicKey === (edu?.documentId || edu?.id || index)}
                                                                                >
                                                                                    {savingAcademicKey === (edu?.documentId || edu?.id || index) ? "Saving..." : "Save"}
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => setEditingAcademicKey(null)}
                                                                                    disabled={savingAcademicKey === (edu?.documentId || edu?.id || index)}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <span>
                                                                                {edu?.total_marks != null
                                                                                    ? `${edu.total_marks}%`
                                                                                    : edu?.cgpa || 'N/A'}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => startAcademicEdit(edu, edu?.documentId || edu?.id || index)}
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </Tab>
                                            <Tab eventKey="finance" title="FINANCE DETAIL">
                                                <div className="row">
                                                    <p className='col-6'><strong>Primary Supporter :</strong> {PRIMARY_SUPPORTER_LABELS[fields?.primary_supporter] || fields?.primary_supporter || 'N/A'}</p>
                                                    <p className='col-6'><strong>Profession Of Father :</strong> {financedetail && financedetail.profession ? financedetail?.profession : 'N/A'}</p>
                                                    {/* <div className='col-6 row'> */}
                                                    <p className='col-6'><strong>Income (Annual) of Father/Guardian:</strong> {financedetail && financedetail.income ? financedetail?.income : 'N/A'}</p>
                                                    <p className='col-6'><strong>Number of Dependents on Father/Guardian:</strong> {financedetail && financedetail.dependents ? financedetail?.dependents : 'N/A'}</p>
                                                    <p className='col-6'><strong>Requested Funding Amount:</strong> {financedetail && financedetail.funds_request ? financedetail?.funds_request : 'N/A'}</p>
                                                    <p className='col-6'><strong>Requested Funding On</strong> {financedetail && financedetail.funds_request_against ? financedetail?.funds_request_against : 'N/A'}</p>

                                                    {/* </div> */}
                                                    {/* <div className='col-6 row'> */}
                                                   
                                                    <p className="col-6">
                                                    <strong>Are you getting any scholarship from any organization:</strong>{' '}
                                                    {financedetail && financedetail.scholarship !== undefined
                                                      ? financedetail.scholarship
                                                        ? 'Yes'
                                                        : 'No'
                                                      : 'N/A'}
                                                  </p>
                                                    {/* </div> */}
                                                    <p className='col-6'><strong>Name of Organization:</strong> {financedetail && financedetail.organization ? financedetail.organization : 'N/A'}</p>
                                                   
                                                    <p className='col-6'><strong>Receiving Amount:</strong> {financedetail && financedetail.amount ? financedetail.amount : 'N/A'}</p>
                                                    <p className='col-6'><strong>Amount Received is :</strong> {financedetail && financedetail.payment_frequency ? financedetail.payment_frequency : 'N/A'}</p>

                                                </div>
                                            </Tab>
                                            <Tab eventKey="bank" title="BANK INFORMATION">
                                                <div className="row">
                                                    <p className='col-6'><strong>Bank Name:</strong> {financedetail && financedetail.bank_name ? financedetail.bank_name : 'N/A'}</p>
                                                    <p className='col-6'><strong>Account Title:</strong> {financedetail && financedetail.account_title ? financedetail.account_title : 'N/A'}</p>
                                                    <p className='col-6'><strong>Account Number:</strong> {financedetail && financedetail.account_number ? financedetail.account_number : 'N/A'}</p>
                                                    <p className='col-6'><strong>IBAN:</strong> {financedetail && financedetail.iban ? financedetail.iban : 'N/A'}</p>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="challan" title="CHALLAN AMOUNT">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="eval-score-card mb-3">
                                                            <div className="eval-score-card__header">
                                                                <span className="eval-score-card__label">Challan Amount</span>
                                                                <span className="eval-score-card__value">PKR {financedetail?.chalan || 0}</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={financedetail?.chalan || 0}
                                                                onChange={(e) => setFinanceDetail((prev) => ({ ...prev, chalan: e.target.value }))}
                                                                min="0"
                                                                placeholder="Enter Challan Amount"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary mt-3 px-4"
                                                                style={{ color: '#fff', fontWeight: 600 }}
                                                                onClick={updateChalan}
                                                            >
                                                                Update Challan
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="acedemic_uploads" title="ACADEMIC UPLOADS">
                                                <div className="row view-docs">
                                                    {acedemicuploads?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div>
                                                                <div className="doc-card__name">Mark Sheet</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2" onClick={() => window.open(acedemicuploads.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div><div className="doc-card__name">Mark Sheet</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}
                                                </div>
                                            </Tab>
                                            <Tab eventKey="resume" title="DOCUMENTS">
                                                <div className="row view-docs">
                                                    {resume1?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Card"></i></div>
                                                                <div className="doc-card__name">Applicant CNIC Front</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume1.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Card"></i></div><div className="doc-card__name">Applicant CNIC Front</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume2?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Card"></i></div>
                                                                <div className="doc-card__name">Applicant CNIC Back</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume2.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Card"></i></div><div className="doc-card__name">Applicant CNIC Back</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume3?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-ID-2"></i></div>
                                                                <div className="doc-card__name">Student ID Card</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume3.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-ID-2"></i></div><div className="doc-card__name">Student ID Card</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume4?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Card"></i></div>
                                                                <div className="doc-card__name">Father/Guardian CNIC Front</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume4.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Card"></i></div><div className="doc-card__name">Father/Guardian CNIC Front</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume5?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Card"></i></div>
                                                                <div className="doc-card__name">Father/Guardian CNIC Back</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume5.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Card"></i></div><div className="doc-card__name">Father/Guardian CNIC Back</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume6?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Receipt"></i></div>
                                                                <div className="doc-card__name">Paid Fee Challan</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume6.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Receipt"></i></div><div className="doc-card__name">Paid Fee Challan</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {resume7?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-Light-Bulb"></i></div>
                                                                <div className="doc-card__name">Electricity Bill</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(resume7.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-Light-Bulb"></i></div><div className="doc-card__name">Electricity Bill</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {fields?.death_certificate?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div>
                                                                <div className="doc-card__name">Death Certificate</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(fields.death_certificate.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div><div className="doc-card__name">Death Certificate</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {fields?.proof_of_relationship?.url ? (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div>
                                                                <div className="doc-card__name">Proof of Relationship (FRC)</div>
                                                                <div className="doc-card__status text-success">✓ Attached</div>
                                                                <button type="button" className="btn btn-outline-primary mt-2 px-3" onClick={() => window.open(fields.proof_of_relationship.url, '_blank')}>View</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="col-lg-3 col-md-4 col-sm-6 mb-3"><div className="doc-card doc-card--empty"><div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div><div className="doc-card__name">Proof of Relationship (FRC)</div><div className="doc-card__status text-muted">N/A</div></div></div>
                                                    )}

                                                    {fields?.relationship_detail ? (
                                                        <div className="col-12 mb-3">
                                                            <div className="doc-card">
                                                                <div className="doc-card__icon"><i className="i-File-Clipboard-Text--Image"></i></div>
                                                                <div className="doc-card__name">Relationship Detail</div>
                                                                <div className="doc-card__status text-muted">{fields.relationship_detail}</div>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Tab>
                                           
                                            <Tab eventKey="personalstatement" title="PERSONAL STATEMENT">
                                                <div className="row">
                                                    <p className='col-6'><strong>Personal Statement :</strong> {personalstatement && personalstatement.personal_statement ? personalstatement?.personal_statement : 'N/A'}</p>
                                                </div>
                                            </Tab>

                                            <Tab eventKey="email" title="SEND EMAIL">
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <label className="form-label mb-1"><strong>To</strong></label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={fields?.email || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <label className="form-label mb-1"><strong>Subject</strong></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Email subject"
                                                            value={emailSubject}
                                                            onChange={(event) => setEmailSubject(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <label className="form-label mb-0">
                                                                <strong>Message</strong> (HTML is supported)
                                                            </label>
                                                            <div className="btn-group btn-group-sm" role="group" aria-label="Message editor mode">
                                                                <button
                                                                    type="button"
                                                                    className={`btn ${emailEditorMode === "visual" ? "btn-primary" : "btn-outline-secondary"}`}
                                                                    onClick={() => setEmailEditorMode("visual")}
                                                                >
                                                                    Visual
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className={`btn ${emailEditorMode === "html" ? "btn-primary" : "btn-outline-secondary"}`}
                                                                    onClick={() => setEmailEditorMode("html")}
                                                                >
                                                                    HTML
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {emailEditorMode === "visual" ? (
                                                            <RichTextEditor
                                                                content={emailBody}
                                                                handleContentChange={setEmailBody}
                                                                placeholder="Write the message here. Pasted text keeps its line breaks."
                                                            />
                                                        ) : (
                                                            <textarea
                                                                className="form-control"
                                                                rows={10}
                                                                placeholder="Write the message here. HTML tags are rendered in the email."
                                                                value={emailBody}
                                                                onChange={(event) => setEmailBody(event.target.value)}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="va-email-preview"
                                                                checked={emailPreview}
                                                                onChange={(event) => setEmailPreview(event.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="va-email-preview">
                                                                Preview rendered HTML
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                {emailPreview && emailBody ? (
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <label className="form-label mb-1"><strong>Preview</strong></label>
                                                            <div
                                                                className="border rounded p-3 bg-white"
                                                                style={{ minHeight: 120 }}
                                                                dangerouslySetInnerHTML={{ __html: emailBody }}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary text-white"
                                                            onClick={sendEmailToApplicant}
                                                            disabled={!emailSubject || !emailBody || sendingEmail}
                                                        >
                                                            <i className="i-Email"></i> Send Email
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <label className="form-label mb-1"><strong>Email History</strong></label>
                                                        {emailLogs.length === 0 ? (
                                                            <p className="text-muted mb-0">No emails sent to this applicant yet.</p>
                                                        ) : (
                                                            emailLogs.map((log) => {
                                                                const logKey = log.documentId || log.id;
                                                                const isExpanded = expandedEmailLog === logKey;
                                                                return (
                                                                    <div className="va-email-log" key={logKey}>
                                                                        <div className="va-email-log__head">
                                                                            <div>
                                                                                <strong>{log.subject || "(no subject)"}</strong>
                                                                                <div className="va-email-log__meta">
                                                                                    To: {log.recipient_email} &middot; By: {log.sent_by || "Admin"} &middot; {new Date(log.sent_at).toLocaleString()}
                                                                                </div>
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                onClick={() => setExpandedEmailLog(isExpanded ? null : logKey)}
                                                                            >
                                                                                {isExpanded ? "Hide" : "View message"}
                                                                            </button>
                                                                        </div>
                                                                        {isExpanded && log.body ? (
                                                                            <div
                                                                                className="va-email-log__body border rounded p-3 bg-white mt-2"
                                                                                dangerouslySetInnerHTML={{ __html: log.body }}
                                                                            />
                                                                        ) : null}
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                </div>
                                            </Tab>

                                        </Tabs>
                                    </SimpleCard>
                                </Col>
                            </Row>
                        </div>
                    )}
            </div>
            <NotificationContainer/>
        </div>
        {/* Full-screen overlay shown while the email is being sent — blocks all interaction */}
        {sendingEmail && (
            <div className="va-overlay">
                <div className="va-overlay__spinner" aria-label="Loading" role="status" />
            </div>
        )}
        <style>{`
            .va-overlay {
                position: fixed; inset: 0; z-index: 100;
                background: rgba(255, 255, 255, .75);
                display: grid; place-items: center;
                backdrop-filter: blur(2px); -webkit-backdrop-filter: blur(2px);
            }
            .va-overlay__spinner {
                width: 48px; height: 48px; border-radius: 50%;
                border: 4px solid #dfe6e4; border-top-color: #0f766e;
                animation: va-spin .7s linear infinite;
            }
            @keyframes va-spin { to { transform: rotate(360deg) } }
            .view-application-tabs .nav-tabs {
                border-bottom: 2px solid #e0e0e0;
                margin-bottom: 1.5rem;
            }
            .view-application-tabs .nav-tabs .nav-link {
                border: none;
                border-bottom: 3px solid transparent;
                color: #6c757d;
                font-weight: 600;
                font-size: 14px;
                padding: 0.75rem 1.25rem;
                transition: all 0.2s ease;
                border-radius: 0;
            }
            .view-application-tabs .nav-tabs .nav-link:hover {
                color: #333;
                border-bottom: 3px solid #ccc;
            }
            .view-application-tabs .nav-tabs .nav-link.active {
                color: #0d6efd;
                border-bottom: 3px solid #0d6efd;
                background: transparent;
            }
            .doc-card {
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                padding: 1.25rem 1rem;
                text-align: center;
                transition: all 0.2s ease;
                background: #fff;
                height: 100%;
            }
            .doc-card:hover {
                box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                border-color: #0d6efd;
            }
            .doc-card--empty {
                opacity: 0.5;
            }
            .doc-card__icon {
                font-size: 36px;
                color: #0d6efd;
                margin-bottom: 0.75rem;
            }
            .doc-card__name {
                font-size: 13px;
                font-weight: 600;
                color: #333;
                margin-bottom: 0.5rem;
            }
            .doc-card__status {
                font-size: 12px;
                margin-bottom: 0.5rem;
            }
            .eval-score-card {
                background: #f8f9fa;
                border-radius: 8px;
                padding: 1rem 1.25rem;
                border: 1px solid #e9ecef;
            }
            .eval-score-card__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0.5rem;
            }
            .eval-score-card__label {
                font-weight: 600;
                font-size: 14px;
                color: #333;
            }
            .eval-score-card__value {
                font-weight: 700;
                font-size: 14px;
                color: #0d6efd;
            }
            .eval-score-card__hint {
                font-size: 12px;
                color: #6c757d;
                margin: 0.4rem 0 0;
            }
            .eval-range {
                width: 100%;
                height: 8px;
                -webkit-appearance: none;
                appearance: none;
                background: #e0e0e0;
                border-radius: 4px;
                outline: none;
            }
            .eval-range::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                background: #0d6efd;
                cursor: pointer;
                border: 3px solid #fff;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
            }
            .eval-range::-moz-range-thumb {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                background: #0d6efd;
                cursor: pointer;
                border: 3px solid #fff;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
            }
            .eval-total-score {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: #e8f0fe;
                border-radius: 8px;
                padding: 0.75rem 1.25rem;
                border: 1px solid #b6d4fe;
            }
            .eval-total-score__label {
                font-weight: 600;
                font-size: 15px;
                color: #333;
            }
            .eval-total-score__badge {
                font-weight: 700;
                font-size: 20px;
                color: #0d6efd;
            }
            .eval-decision {
                background: #f8f9fa;
                border-radius: 8px;
                padding: 1rem 1.25rem;
                border: 1px solid #e9ecef;
            }
            .eval-decision__label {
                font-weight: 600;
                font-size: 14px;
                color: #333;
                display: block;
                margin-bottom: 0.75rem;
            }
            .eval-decision__buttons {
                display: flex;
                gap: 1rem;
            }
            .eval-decision__buttons .btn {
                flex: 1;
                padding: 0.5rem 1rem;
                font-weight: 600;
                font-size: 14px;
            }
            .va-email-log {
                border: 1px solid #e9ecef;
                border-radius: 8px;
                padding: 0.75rem 1rem;
                margin-bottom: 0.5rem;
                background: #f8f9fa;
            }
            .va-email-log__head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 1rem;
            }
            .va-email-log__meta {
                font-size: 12px;
                color: #6c757d;
                margin-top: 0.2rem;
            }
            .va-email-log__body {
                font-size: 14px;
            }
        `}</style>
        </>
    );
};

export default ViewApplication;
